export default __webpack_public_path__ + "static/media/pictureP.c111a08c.png";